import { getDomainRestrictionsForItems } from 'reactApp/appHelpers/appHelpers';
import { getDomainFoldersFilterActive } from 'reactApp/modules/home/home.selectors';
import { createNewItem } from 'reactApp/modules/modifying/modifying.actions';
import { showSnackbarAction } from 'reactApp/modules/snackbar/snackbar.actions';
import { SnackbarTypes } from 'reactApp/modules/snackbar/snackbar.types';
import { store as reduxStore } from 'reactApp/store';

import { getCurrentFolder } from './helpers/getCurrentFolder';

export const create = (
    type: string,
    from: string,
    showShareOnlyButton?: boolean,
    gaPrefix = '',
    inHomeRoot = false,
    createdInToolbar?: boolean
): void => {
    const state = reduxStore.getState();
    const domainFoldersFilterActive = getDomainFoldersFilterActive(state);
    const currentFolder = getCurrentFolder(state);
    const { isDomainAndCreateRestricted } = getDomainRestrictionsForItems(currentFolder);

    /**
     * B2BCLOUD-3295
     * Если пытаемся загрузить в корень раздела доменных папок, то показываем запрещающий snack
     */

    if (domainFoldersFilterActive || isDomainAndCreateRestricted) {
        reduxStore.dispatch(
            showSnackbarAction({
                id: 'upload-error',
                text: 'У вас нет прав для загрузки и создания в этой папке',
                type: SnackbarTypes.failure,
                closable: true,
            })
        );
        return;
    }

    reduxStore.dispatch(
        createNewItem({
            type,
            from,
            showShareOnlyButton,
            gaPrefix,
            inHomeRoot,
            createdInToolbar,
        })
    );
};
